export default {
 //   baseApi: 'https://localhost:2300/api',
 //  baseImg: 'https://localhost:2300',

    baseApi: 'https://admin.sky-flight.com.ar/api',
    baseImg: 'https://admin.sky-flight.com.ar',
};
